/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
function t(t){return"fill"===t.type}function e(t){return"extrude"===t.type}export{e as isExtrudeSymbol3DLayer,t as isFillSymbol3DLayer};
